import {
  CSSProperties,
  HTMLAttributes,
  ReactNode,
  useMemo,
  forwardRef,
} from "react";

interface IProps {
  children: ReactNode;
  direction?: "row" | "column";
  mobileDirection?: "row" | "column";
  attributes?: HTMLAttributes<HTMLDivElement>;
  flex?: string | number;
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "stretch";
  alignItems?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "stretch"
    | "baseline"
    | "stretch";
  gap?: number;
  minHeight?: number | string;
  maxWidth?: number | string;
  padding?: number | string;
  style?: CSSProperties;
}

const Flex = forwardRef<HTMLDivElement, IProps>(function Flex(
  props,
  ref,
): JSX.Element {
  const style = useMemo<CSSProperties>(
    () => ({
      display: "flex",
      flex: props.flex,
      flexDirection: props.direction ?? "row",
      justifyContent: props.justifyContent ?? "center",
      alignItems: props.alignItems ?? "center",
      gap: props.gap ?? 20,
      padding: props.padding,
      minHeight: props.minHeight,
      maxWidth: props.maxWidth,
      ...props.attributes?.style,
      ...props.style,
    }),
    [props],
  );

  return (
    <div
      ref={ref}
      {...props.attributes}
      style={style}
      children={props.children}
    />
  );
});

export { Flex };
